import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
const NAV = [
  { to: '/', icon: '📊', label: 'Dashboard', end: true },
  { to: '/transactions', icon: '📋', label: 'Transactions' },
  { to: '/upload', icon: '📤', label: 'Upload Statement' },
  { to: '/reports', icon: '📈', label: 'Reports' },
  { to: '/liabilities', icon: '💳', label: 'Liabilities' },
  { to: '/accounts', icon: '🏦', label: 'Accounts' },
  { to: '/rules', icon: '⚙️', label: 'Rules & Categories' },
];
export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleLogout = () => { logout(); navigate('/login'); };
  return (
    <div className="app-shell">
      {sidebarOpen && <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 99 }} onClick={() => setSidebarOpen(false)} />}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo"><h1>💰 FinTrack</h1><span>Personal Finance</span></div>
        <nav className="sidebar-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} onClick={() => setSidebarOpen(false)}>
              <span className="icon">{n.icon}</span>{n.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', marginBottom: 8 }}>{user?.email}</div>
          <button className="btn btn-outline btn-sm" style={{ color: 'rgba(255,255,255,0.7)', borderColor: 'rgba(255,255,255,0.2)', width: '100%' }} onClick={handleLogout}>Sign Out</button>
        </div>
      </aside>
      <div className="main-content">
        <header className="topbar">
          <button className="mobile-menu-btn btn btn-ghost" onClick={() => setSidebarOpen(true)} style={{ fontSize: 20 }}>☰</button>
          <div style={{ flex: 1 }} />
          <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>{new Date().toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })}</span>
        </header>
        <main className="page"><Outlet /></main>
      </div>
    </div>
  );
}
